import { BookingSource } from "enums";

// Whether a PARTICULAR RECORD came from EatApp. Use this only to decide which field of a
// payload to read: an EatApp reservation carries its bill on `amount` and its notes on
// `note`, and its line items hold no money at all, so those choices follow the record no
// matter which venue it is being viewed from.
//
// For hiding or showing a FEATURE, use `isEatappVenue(venue)` from `venue.service.js`.
// The BE now carries the flag on the venue profile as `eatAppIntegration` (SVEMS-998), and
// that is what every label, column and tab is gated on.
export const isEatappSource = (source) => source === BookingSource.EATAPP;
